import { PagePayload } from '@core/interface/core';
import {
  AddDepartmentResponse,
  DeletedDepartment,
  DepartmentError,
  DepartmentItem,
  DepartmentResponse,
} from '@core/interface/department';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const DepartmentActions = createActionGroup({
  source: 'Department',
  events: {
    'Load Departments': props<PagePayload>(),
    'Load Departments Success': props<DepartmentResponse>(),
    'Load Departments Failure': props<DepartmentError>(),
    'Add Edit Department': props<DepartmentItem>(),
    'Add Department Success': props<AddDepartmentResponse>(),
    'Update Department Success': props<AddDepartmentResponse>(),
    'Add Department Failure': props<DepartmentError>(),
    'Update Department Failure': props<DepartmentError>(),
    'Delete Department': props<{ id: number }>(),
    'Delete Department Success': props<DeletedDepartment>(),
    'Delete Department Failure': props<DepartmentError>(),
    'Reset Delete Status': emptyProps(),
    'Reset Departments': emptyProps(),
  },
});
